import React from "react";
import { Controller } from "react-hook-form";
import { getValidationResultFromFormError } from "../../common/validations";
import FormDevTool from "../../components/FormDevTool";
import { FormField, FormFieldSet } from "../../components/FormField";
import { CellBlockFooter } from "../../components/Grid/CellBlock";
import TextInput from "../../components/TextInput";
import { UnitInfoFormData, useUnitInfoForm } from "./UnitView.hooks";

interface Props extends ReturnType<typeof useUnitInfoForm> {
    onCancel: () => void;
    onSubmit: (data: UnitInfoFormData) => void;
    isNewForm?: boolean;
    isSubmitLoading?: boolean;
}

const UnitInfoForm = (props: Props) => {
    return (
        <form onSubmit={props.handleSubmit(props.onSubmit)}>
            <FormField>
                <Controller
                    name="name"
                    control={props.control}
                    render={({
                        field: { onBlur, onChange, value },
                        fieldState,
                    }) => (
                        <TextInput
                            value={value}
                            onBlur={onBlur}
                            onChange={onChange}
                            autoComplete="on"
                            required
                            placeholder="Namn"
                            validation={getValidationResultFromFormError(
                                fieldState
                            )}
                        />
                    )}
                />
            </FormField>
            <FormField>
                <Controller
                    name="line1"
                    control={props.control}
                    render={({
                        field: { onBlur, onChange, value },
                        fieldState,
                    }) => (
                        <TextInput
                            value={value}
                            onBlur={onBlur}
                            onChange={onChange}
                            autoComplete="on"
                            required
                            placeholder="Gatuadress"
                            validation={getValidationResultFromFormError(
                                fieldState
                            )}
                        />
                    )}
                />
            </FormField>
            <FormFieldSet>
                <FormField halfSize>
                    <Controller
                        name="postalCode"
                        control={props.control}
                        render={({
                            field: { onBlur, onChange, value },
                            fieldState,
                        }) => (
                            <TextInput
                                value={value}
                                onBlur={onBlur}
                                onChange={onChange}
                                autoComplete="on"
                                required
                                placeholder="Postnummer"
                                validation={getValidationResultFromFormError(
                                    fieldState
                                )}
                            />
                        )}
                    />
                </FormField>
                <FormField halfSize>
                    <Controller
                        name="town"
                        control={props.control}
                        render={({
                            field: { onBlur, onChange, value },
                            fieldState,
                        }) => (
                            <TextInput
                                value={value}
                                onBlur={onBlur}
                                onChange={onChange}
                                autoComplete="on"
                                required
                                placeholder="Ort"
                                validation={getValidationResultFromFormError(
                                    fieldState
                                )}
                            />
                        )}
                    />
                </FormField>
            </FormFieldSet>
            <FormFieldSet>
                <FormField halfSize>
                    <Controller
                        name="stairs"
                        control={props.control}
                        render={({
                            field: { onBlur, onChange, value },
                            fieldState,
                        }) => (
                            <TextInput
                                value={value}
                                onBlur={onBlur}
                                onChange={onChange}
                                autoComplete="on"
                                type="tel"
                                placeholder="Trappor"
                                validation={getValidationResultFromFormError(
                                    fieldState
                                )}
                            />
                        )}
                    />
                </FormField>
                <FormField halfSize>
                    <Controller
                        name="doorCode"
                        control={props.control}
                        render={({
                            field: { onBlur, onChange, value },
                            fieldState,
                        }) => (
                            <TextInput
                                value={value}
                                onBlur={onBlur}
                                onChange={onChange}
                                autoComplete="on"
                                type="tel"
                                placeholder="Portkod"
                                validation={getValidationResultFromFormError(
                                    fieldState
                                )}
                            />
                        )}
                    />
                </FormField>
            </FormFieldSet>
            <FormField noMargin>
                <Controller
                    name="phone"
                    control={props.control}
                    render={({
                        field: { onBlur, onChange, value },
                        fieldState,
                    }) => (
                        <TextInput
                            value={value}
                            onBlur={onBlur}
                            onChange={onChange}
                            autoComplete="on"
                            required
                            type="tel"
                            placeholder="Telefonnummer"
                            validation={getValidationResultFromFormError(
                                fieldState
                            )}
                        />
                    )}
                />
            </FormField>
            <FormDevTool control={props.control} />
            <CellBlockFooter
                disableSubmit={
                    !props.formState.isValid || !props.formState.isDirty
                }
                hasChangesText={
                    !props.isNewForm && props.formState.isDirty
                        ? "Förmuläret har osparade ändringar."
                        : undefined
                }
                marginTop
                isLoading={props.isSubmitLoading}
                onCancel={props.onCancel}
                submitButtonType="submit"
            />
        </form>
    );
};

export default UnitInfoForm;
